export default "__VITE_ASSET__CJ1IK3nT__"